
export class ActivePatient {
    id: string | null;
    firstName: string | null;
    lastName: string | null;
    fullName: string | null;
    isPatient: boolean;
}
